import flatten from 'lodash/flatten';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import progressServices from '@progress/duck/services';
import esbApiService from '@utils/http/esbApiService';

import {
  appendRecordedByInfo,
  buildCompletionDateParams,
  denormalizeActivityItems,
} from '../activityUtils';
import { mapAdvancementImportDtoToModel } from '../utils';

const advancementImportCall$ = (organizationGuid, adults) =>
  esbApiService
    .get$(`/persons/advancementImports?organizationGuid=${organizationGuid}`, {
      gtm: {
        label: '/persons/advancementImports',
      },
    })
    .map(res => mapAdvancementImportDtoToModel(res, adults));

const mapActivityItemsDtoToModel = dto =>
  flatten(dto.map(denormalizeActivityItems));

const activitiesHistoryCall$ = (
  { organizationGuid, updatedDate, adults },
  { dispatch },
) => {
  const { completionDateStart, completionDateEnd } =
    buildCompletionDateParams(updatedDate);

  return progressServices
    .getActivities$(
      {
        organizationGuid,
        startDateTime: completionDateStart,
        endDateTime: completionDateEnd,
        showAll: true,
        perPage: 1000,
      },
      { dispatch },
    )
    .pipe(
      catchError(() => of([])),
      map(mapActivityItemsDtoToModel),
      map(activities => appendRecordedByInfo(activities, adults)),
    );
};

const getUnitHistory$ = (
  { organizationGuid, updatedDate, adults },
  { dispatch },
) =>
  forkJoin(
    advancementImportCall$(organizationGuid, adults),
    activitiesHistoryCall$(
      { organizationGuid, updatedDate, adults },
      { dispatch },
    ),
  ).pipe(
    map(flatten),
    map(res =>
      res.map((row, i) => ({
        ...row,
        key: i,
      })),
    ),
  );

export default {
  getUnitHistory$,
  mapActivityItemsDtoToModel,
};
